import {createStore, combineReducers} from "redux"

import { cartReducer } from "../features/cart/cartSlice"
import { inventoryReducer } from "../features/items/itemSlice"

const reducer = {
    cart: cartReducer,
    inventory: inventoryReducer
}

export const store = createStore(combineReducers(reducer))

